// GA4 event helper — no-op when gtag isn't loaded. Never pass client PII.
export function gaEvent(name, params = {}) {
  try {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", name, { ...params, page_path: window.location.pathname });
  } catch {
    /* analytics must never break the UI */
  }
}
